import React from 'react';

const ScormIcon: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="SCORM"
  >
    <path
      d="M17 6.5C17 4.6 14.8 3 12 3C9.2 3 7 4.6 7 6.8C7 9 9.5 9.8 12 10.4C14.5 11 17 11.7 17 14.2C17 16.4 14.8 18 12 18C9.2 18 7 16.4 7 14.5"
      fill="none"
      stroke="var(--pgn-color-headings-base)"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
  </svg>
);

export default ScormIcon;
